import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';

const PagesLayout = ({ children, noImg, className }) => (
  <div className={`pages-wrapper ${className ? className : ''}`}>
    <div className={`image-placeholder ${noImg ? 'no-img' : ''}`}>
      <Grid>
        <Row>
          <Col xs={12} md={noImg ? 12 : 6}>
            {children}
          </Col>
        </Row>
      </Grid>
    </div>
  </div>
);

PagesLayout.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default PagesLayout;



// WEBPACK FOOTER //
// ./src/features/pages/PagesLayout.js